import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Source } from 'src/app/models/source';
import { AuthService } from 'src/app/services/auth.service';
import { MainAppService } from 'src/app/services/main-app.service';
import { MarketingChannelsDetailComponent } from '../marketing-channels-detail/marketing-channels-detail.component';
@Component({
  selector: 'app-marketing-channels',
  templateUrl: './marketing-channels.component.html',
  styleUrls: ['./marketing-channels.component.css']
})
export class MarketingChannelsComponent implements OnInit {
  displayedColumns: string[] = ['sourceId', 'description', 'langId', 'langGroup', 'inactive'];
  dataSource :any =[];

  constructor(
    public dialog: MatDialog,
    public mainAppService: MainAppService, 
    public auth: AuthService) {}

  ngOnInit(): void {
    this.search();
  }

  search() {
    this.mainAppService.getSources().subscribe(retval => 
      {
        if (retval && retval.responseData){
          this.dataSource = new MatTableDataSource(retval.responseData)
        }
      });
  }

  showDetails(source: Source){
    var dialogRef = this.dialog.open(MarketingChannelsDetailComponent, {
      width: '400px',
      data: source
    });
    
    dialogRef.afterClosed().subscribe(result => {
      this.search();
    });
  }

  createNew(){
    var source = new Source();
    source.sourceId = -1;
    var dialogRef = this.dialog.open(MarketingChannelsDetailComponent, {
      width: '400px',
      data: source
    });

    dialogRef.afterClosed().subscribe(result => {
      this.search();
    });
  }
}
